// emit custom events when a named media query becomes active or inactive

if (window.matchMedia) {
    const names = {
        '(max-width: 480px)': 's',
        '(min-width: 481px)': 'm',
        '(min-width: 768px)': 'l',
    };

    const events = {};

    const findMatch = function (media) {
        const x = Array.from(names).filter(
            (name, mq) => media.includes(mq) || media.includes(mq.replace(' ', '')),
        );
        return x.length ? x[0] : '';
    };

    const handler = function (e) {
        const name = `breakpoint.${e.matches ? 'active' : 'inactive'}.${findMatch(e.media)}`;
        document.dispatchEvent(events[name]);
    };

    const doIteration = function (name) {
        name = `breakpoint.${name}.${findMatch(this.media)}`;
        events[name] = new CustomEvent(name);
    };

    Object.keys(names).forEach((key) => {
        const mql = window.matchMedia(key);
        ['active', 'inactive'].forEach(doIteration, mql);
        mql.addListener(handler);

        if (mql.matches) {
            window.addEventListener('load', handler.bind(mql, mql));
        }
    });
}
